/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

export const premiumFeatureTooltip = 'Includes premium features';
export const premiumPluginTooltip = 'Premium feature';
export const conflictInside = 'See inside to learn details about conflicts';
export const conflictBelow = 'See below to learn details about conflicts';
export const allFeaturesDisabled = 'All features inside this capability are disabled.';
export const allPluginsDisabled = 'All plugins inside this feature are disabled.';
